import React from 'react';
import iconRrss from '../assets/images/rrss.png';
import iconRrss2 from '../assets/images/rrss2.png';
import iconUmmore from '../assets/images/ummore.jpeg';
import iconMussa from '../assets/images/mussa.png';
import iconCoppel from '../assets/images/coppel.webp';
import iconCya from '../assets/images/cya.png';
import iconFarmasi from '../assets/images/farmasi.jpg';
import iconTontoapp from '../assets/images/tontoapp.webp';
import iconTuperchero from '../assets/images/tuperchero.png';
import iconStats from '../assets/images/stats.png';
import iconPaovallez from '../assets/images/paovallez.jpeg';

function Contact() {
    return (
        <article className="content active" data-page="about">
            <header>
                <h2 className="h2 article-title">Proyectos</h2>
            </header>

            <section className="blog-posts">
                <ul className="blog-posts-list">
                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconTontoapp} alt="icono TontoApp" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">@tontoapp</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Community manager</time>
                                </div>
                                <h3 className="h3 blog-item-title">Tonto App</h3>
                                <p className="blog-text">
                                    Aplicación de audio que te ayuda a grabar tu podcast, narrar historias y transmitir curiosidades a amigos con intereses similares.
                                </p>
                            </div>
                        </a>
                    </li>

                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconTuperchero} alt="icono Tuperchero" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">@tuperchero_mx</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Project Manager | Creadora de Contenido | Comercial</time>
                                </div>
                                <h3 className="h3 blog-item-title">Tu perchero</h3>
                                <p className="blog-text">
                                    Tienda de ropa de segunda mano.
                                </p>
                            </div>
                        </a>
                    </li>

                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconMussa} alt="icono Mussa" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">@productosmussa</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Project Manager</time>
                                </div>
                                <h3 className="h3 blog-item-title">Mussa</h3>
                                <p className="blog-text">
                                    Productos con una gran gama de material escolar.
                                </p>
                            </div>
                        </a>
                    </li>

                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconCya} alt="icono C&A" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">@cyamoda</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Creadora de contenido</time>
                                </div>
                                <h3 className="h3 blog-item-title">C&A</h3>
                                <p className="blog-text">
                                    Cadena internacional de negocios de ropa.
                                </p>
                            </div>
                        </a>
                    </li>

                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconCoppel} alt="icono Coppel" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">@coppel</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Creadora de contenido</time>
                                </div>
                                <h3 className="h3 blog-item-title">Coppel</h3>
                                <p className="blog-text">
                                    Cadena de tiendas departamentales que ofrece una gran variedad de productos
                                </p>
                            </div>
                        </a>
                    </li>

                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconFarmasi} alt="icono Farmasi" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">@farmasimexico</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Creadora de contenido</time>
                                </div>
                                <h3 className="h3 blog-item-title">Farmasi</h3>
                                <p className="blog-text">
                                    Fabricante internacional en productos de belleza, cuidado personal, accesorios, hogar y bienestar.
                                </p>
                            </div>
                        </a>
                    </li>

                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconUmmore} alt="icono Ummore" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">@Ummore</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Project Manager | Creadora de contenido | Estratega de redes sociales</time>
                                </div>
                                <h3 className="h3 blog-item-title">Ummore</h3>
                                <p className="blog-text">
                                    Ofrece evaluaciones y tests psicométricos con inteligencia artificial para la contratación del talento a precios sorprendentes.
                                </p>
                            </div>
                        </a>
                    </li>

                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconStats} alt="icono estadísticas" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">Paola Valle</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Creadora de Contenido</time>
                                </div>
                                <h3 className="h3 blog-item-title">Estadísticas</h3>
                                <p className="blog-text">
                                    Planificación estratégica para gestionar proyectos eficientemente. Favorezco el crecimiento de una empresa mediante el uso de herramientas de comunicación, tanto digitales como presenciales.
                                </p>
                            </div>
                        </a>
                    </li>

                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconRrss} alt="icono Rrss Paovallez" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">@paovallez</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Community Manager | Creadora de contenido</time>
                                </div>
                                <h3 className="h3 blog-item-title">Paovallez</h3>
                                <p className="blog-text">
                                    Mis estrategias de contenido basadas en storytelling impulsaron un crecimiento significativo e interacción en plataformas como Instagram y TikTok.
                                </p>
                            </div>
                        </a>
                    </li>

                    <li className="blog-post-item">
                        <a href="#">
                            <figure className="blog-banner-box">
                                <img src={iconRrss2} alt="icono Rrss Paovallez 2" width="40" />
                            </figure>
                            <div className="blog-content">
                                <div className="blog-meta">
                                    <p className="blog-category">@paovallez</p>
                                    <span className="dot"></span>
                                    <time dateTime="2022-02-23">Consultora de imagen</time>
                                </div>
                                <h3 className="h3 blog-item-title">Paola Valle</h3>
                                <p className="blog-text">
                                    Logré potenciar la imagen de más de 100 personas en México, Estados Unidos, Perú, Canadá, Chile y Ecuador. La conexión entre el cuidado de la imagen y el estado de ánimo me cautivó, llevándome a ampliar mis conocimientos y fusionarlos con la comunicación.
                                </p>
                            </div>
                        </a>
                    </li>
                </ul>
            </section>
        </article>
    );
}

export default Contact;
